import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'DECIDI COSA FARE',
        description:
            "Dopo aver modificato l'esercizio premi 'Salva in archivio' per salvare le modifiche apportate all'esercizio, senza aggiungerlo alla tua verifica. Premi 'Salva e aggiungi' per salvare l'esercizio e aggiungerlo direttamente anche alla verifica.",
        isActive: true,
        name: 'EditPageEditorialAnchor',
        tutorialName: 'modifica-esercizi_pulsantiera_ricerca'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
